'use strict';
module.exports = require('./Calendar.vue');